import './abstract_section_view.coffee'
Namespace('Monitoring.Reports.Executive')

class Monitoring.Reports.Executive.TwitterRankingView extends Monitoring.Reports.Executive.AbstractSectionView
  template: JST["backbone/templates/monitoring/reports/executive/generic_template"]
  rankings_template: JST["backbone/templates/monitoring/reports/executive/rankings_template"]
  twitter_template: JST["backbone/templates/monitoring/charts/twitter_user_ranking"]
  tagName: 'section'
  id: 'twitter-ranking'
  className: 'chart-ranking twitter-ranking item w2 h3'
  icon: 'social'

  events:
    'click .download-image': 'onClickDownloadImage'

  initialize: (@options = {}) ->
    @linkExists = false

  _getRankings: ->
    [
      { id: 'positive_user_followers_ranking_chart', searchQuery: @_getPositiveSearchQuery(), rankingClass: 'positive', title: 'Principales por cantidad de followers', url: '/monitoring/dashboard/charts/users_by_followers/', field: 'users', spanSize: '3', longNumber: true },
      { id: 'positive_user_ranking_chart', searchQuery: @_getPositiveSearchQuery(), rankingClass: 'positive', title: 'Principales por cantidad de tweets', url: '/monitoring/dashboard/charts/user/', field: 'users', spanSize: '3', longNumber: true },
      { id: 'negative_user_followers_ranking_chart', searchQuery: @_getNegativeSearchQuery(), rankingClass: 'negative', query: {}, title: 'Principales por cantidad de followers', url: '/monitoring/dashboard/charts/users_by_followers/', field: 'users', spanSize: '3', longNumber: true },
      { id: 'negative_user_ranking_chart', searchQuery: @_getNegativeSearchQuery(), rankingClass: 'negative', title: 'Principales por cantidad de tweets', url: '/monitoring/dashboard/charts/user/', field: 'users', spanSize: '3', longNumber: true },
    ]

  render: ->
    rankings = @_getRankings()
    @$el.html(@template(self: this))
    @bindChartsReady(rankings.length)
    rankingChart = new Monitoring.Views.Charts.RankingChartView({ settings: { exportable: false } })
    @$el.find('.chart_container').html(@rankings_template({rankings: rankings}))
    @_renderRanking(ranking, rankingChart) for ranking in rankings

    @id = new Date().toISOString().replace(/[-:.]/g, '')
    linkToImage = $('<a id="download-' + @id + '" class="download-image" style="float:right;cursor:pointer;"><i class="fa fa-download" style="font-size:20px;"></i></a>')
    @$el.find('#generic-container').prepend(linkToImage)

    return this

  onClickDownloadImage: (evt) ->
    return if @linkExists
    evt.stopPropagation()
    @$el.find('.download-image').hide()
    table = @$el.find('.chart_container')
    tablePlain = table[0]

    # scroll to center the table vertically
    elemTop = table.offset()['top']
    viewportHeight = $(window).height()
    myScroll = elemTop - (viewportHeight / 2);
    $(window).scrollTop(myScroll);

    onrendered = (canvas) =>
      @$el.find('.download-image').show()
      @$el.append(canvas)
      @$el.find('canvas').addClass('canvas').hide()
      @downloadCanvas(evt.currentTarget, 'canvas')
      @$el.find('canvas').remove()
    html2canvas(tablePlain, { onrendered: onrendered, timeout: 30000, useCORS: true })

  downloadCanvas: (link, canvasClass) ->
    filename = $('#' + 'download-' + @id).closest('.container').find('h1')[0].innerHTML
    link.href = @$el.find('.' + canvasClass)[0].toDataURL()
    link.download = filename
    @linkExists = true
    @undelegateEvents()
    setTimeout () =>
      link.click()
      @delegateEvents()
    , 800

  _renderRanking: (ranking, rankingChart) ->
    rankingChart.setSearchQuery(ranking.searchQuery)
    rankingChart.twitterApi(ranking, @twitter_template, { container: @$el, callback: => @chartReady("##{ranking.id}") })

  _getPositiveSearchQuery: ->
    searchQuery = @_getSearchQuery().deepCopy()
    searchQuery.addSentiment('positive')
    searchQuery

  _getNegativeSearchQuery: ->
    searchQuery = @_getSearchQuery().deepCopy()
    searchQuery.addSentiment('negative')
    searchQuery

  _getSearchQuery: ->
    searchQuery = new Monitoring.Models.SearchQuery(@getExtraQuery(), { use_defaults: false })
    searchQuery.addDateFrom(@options.fromISO)
    searchQuery.addDateTo(@options.toISO)
    searchQuery.addLabel(code) for code in @options.settings.accountLabel.codes
    searchQuery
